module.exports = __webpack_public_path__ + "static/img/13.34ae8b3a.png";